/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */

import Utils from '../utils/utils.js';

export default class Navigation {
	constructor() {
		this.container = document.getElementById( 'site__navigation' );
		this.button = this.container.getElementsByTagName( 'button' )[0];
		this.menu = this.container.getElementsByClassName( 'site__navigation-menu' )[0];
	}

	setupNavigation() {
		if ( ! this.container || 'undefined' === typeof this.button ) {
			return;
		}

		// Hide menu toggle button if menu is empty and return early.
		if ( 'undefined' === typeof this.menu ) {
			this.button.style.display = 'none';

			return;
		}

		// Have menu closed by default
		this.menu.setAttribute( 'aria-expanded', 'false' );
		if ( -1 === this.menu.className.indexOf( 'nav-menu' ) ) {
			this.menu.className += ' nav-menu';
		}

		// Toggle mobile navigation
		jQuery( this.button ).on( 'click.oax::navigation-toggle', () => {
			if ( -1 !== this.container.className.indexOf( 'is-open' ) ) {
				this.closeNavigation();
			} else {
				this.openNavigation();
			}	
		} );

		/*
		 * Set Preloder Transition 
		 * on Main nav Links
		 */
		jQuery( this.menu ).find( 'a[href]' ).addClass( 'js--page-transition--preloader' );

		this.setupButtonAnimation();
		// this.navAccessibilitySupport();
	}

	/**
	 * Allow keyboard users to use multi-level navigation
	 */
	navAccessibilitySupport() {
	// Get all the link elements within the menu.
		const links = this.menu.getElementsByTagName( 'a' );

		/*
		 * @todo test if this is working
		 * Each time a menu link is focused or blurred, toggle focus.
		 */
		links.forEach( ( link ) => {
			link.addEventListener( 'focus', link.toggleFocus, true );
			link.addEventListener( 'blur', link.toggleFocus, true );
		} );
	}

	/**
	 * Toggles `focus` class to allow submenu access on tablets.
	 */
	enableTouchFocus() {
		const parentLink = this.container.querySelectorAll( '.menu-item-has-children > a, .page_item_has_children > a' );

		if ( 'ontouchstart' in window ) {
			const touchStartFn = ( e ) => {
				const menuItem = this.parentNode;

				if ( ! menuItem.classList.contains( 'focus' ) ) {
					e.preventDefault();
					for ( let i = 0; i < menuItem.parentNode.children.length; ++i ) {
						if ( menuItem !== menuItem.parentNode.children[i] ) {
							menuItem.parentNode.children[i].classList.remove( 'focus' );
						}
					}
					menuItem.classList.add( 'focus' );
				} else {
					menuItem.classList.remove( 'focus' );
				}
			};

			for ( let i = 0; i < parentLink.length; ++i ) {
				parentLink[i].addEventListener( 'touchstart', touchStartFn, false );
			}
		}
	}

	openNavigation(){
		Utils.scrollLock( true );
		this.container.className += ' is-open';
		this.button.setAttribute( 'aria-expanded', 'true' );
		this.menu.setAttribute( 'aria-expanded', 'true' );
		this.tl.play();	
		
		jQuery( this.menu ).on( 'click.oax::navigation-link-click', 'a', jQuery.proxy( this.closeNavigation, this ) );
	}

	closeNavigation(){
		Utils.scrollLock( false );
		this.container.className = this.container.className.replace( ' is-open', '' );
		this.button.setAttribute( 'aria-expanded', 'false' );
		this.menu.setAttribute( 'aria-expanded', 'false' );
		this.tl.reverse();

		jQuery( this.menu ).off( 'click.oax::navigation-link-click', 'a', jQuery.proxy( this.closeNavigation, this ) );
	}

	/**
	 * Sets or removes .focus class on an element.
	 */
	toggleFocus() {
		let self = this;

		// Move up through the ancestors of the current link until we hit .nav-menu.
		while ( -1 === self.className.indexOf( 'nav-menu' ) ) {
			// On li elements toggle the class .focus.
			if ( 'li' === self.tagName.toLowerCase() ) {
				if ( -1 !== self.className.indexOf( 'focus' ) ) {
					self.className = self.className.replace( ' focus', '' );
				} else {
					self.className += ' focus';
				}
			}

			self = self.parentElement;
		}
	}

	setActiveState() {
		const classActive = 'current-menu-item',
			$links = jQuery( this.menu ).find( ' a[href] ' );

		$links.each( function(){
			let $el = jQuery(this); // eslint-disable-line
			$el.parent( 'li' ).removeClass( classActive ); 
		} );

		$links.filter( function(){
			const $el = jQuery( this ); // eslint-disable-line
			
			if ( window.location.href.endsWith( $el.attr( 'href' ) ) ){
				return true;
			}

			return false;
		} ).parent().addClass( classActive );
	}

	setupButtonAnimation(){
		var self = this,
			barTop = $( '#bar-top' ),
			barMidL = $( '#bar-mid-l' ),
			barMidR = $( '#bar-mid-r' ),
			barBottom = $( '#bar-bottom' ),
			circle = $( '#circle' ),
			menuIcon = $( '#menu-icon' ),
			tl = gsap.timeline( {
				paused: true,
			} );
		
		// gsap.defaultEase = Expo.easeInOut; // Change the default easing
		
		tl
			.to( barTop, 0.3, {
				y: 5,
			} )
			.to( barBottom, 0.3, {
				y: -5,
			}, 0 )
			.to( barTop, 0.4, {
				rotation: 45,
				y: 0,
				x: 10,
				transformOrigin: 'left top',
			}, 0.15 )
			.to( barBottom, 0.4, {
				rotation: -45,
				y: 0,
				x: 10,
				transformOrigin: 'left bottom',
			}, 0.15 )
			.to( barMidL, 0.6, {
				opacity: 0,
				scaleX: 0,
				transformOrigin: 'left',
			}, 0 )
			.to( barMidR, 0.6, {
				opacity: 0,
				scaleX: 0,
				transformOrigin: 'right',
			}, 0 )
			.to( menuIcon, 1.2, {
				rotation: 90,
			}, 0.1 )
			.fromTo( circle, 1.2, {
				opacity: 0,
				scale: 0,
				transformOrigin: '50% 50%',
			}, {
				scale: 1,
				opacity: 1,
				ease: 'elastic.out(1, 0.8)'// Elastic.easeOut.config( 1, 0.8 ),
			}, 0.5 )
			.to( [barTop, barBottom], 0.3, {
				scale: 0.6,
				transformOrigin: '50% 50%',
			}, 0.7 );		
		
		this.tl = tl;
	}
}

